














































import { defineComponent, reactive, toRefs, onBeforeMount } from '@vue/composition-api';

import { useStore } from '@/utils/use-store';
import { ServiceFactory } from '@/service/ServiceFactory';
import { useCategoryList } from '@/composition-functions/useCategory';

import CommonTable from '@/components/CommonTable.vue';
import ExerciseForm from '@/components/Exercise/ExerciseForm.vue';
import { SessionExercise } from '@/helpers/types';

const SessionExercise = ServiceFactory.get('sessionExercise');
// const Session = ServiceFactory.get('session');

export default defineComponent({
  name: 'ExerciseList',

  components: {
    CommonTable,
    ExerciseForm,
  },

  setup(props, context) {
    const store = useStore();
    const { accessToken: token } = store.state.user;

    const {
      drawer,
      mode,
      toggleCreate,
      closeEventHandler,
      fetchSessionExercise,
      exerciseList,
      createExerciseEventHandler,
      loading,
      tempExercise,
      toggleEdit,
      editExerciseEventHandler,
      deleteExerciseEventHandler,
    } = useSessionExercise(props, context, token);

    const { categoryList, fetchCategories } = useCategoryList();

    onBeforeMount(beforeMountEventHandler);

    /**
     * Handler for before mount event
     * */
    async function beforeMountEventHandler() {
      await fetchSessionExercise();
      await fetchCategories(token);
    }

    return {
      drawer,
      mode,
      exerciseList,
      categoryList,
      loading,
      tempExercise,
      toggleEdit,
      createExerciseEventHandler,
      toggleCreate,
      closeEventHandler,
      editExerciseEventHandler,
      deleteExerciseEventHandler,
    };
  },
});

function useSessionExercise(props: any, context: any, token: string) {
  const state = reactive({
    drawer: false,
    mode: 'create',
    tempExercise: {} as SessionExercise,
    exerciseList: [] as SessionExercise[],
    loading: false,
  });


  /**
   * Handle toggle create event
   * */
  function toggleCreate(): void {
    state.drawer = true;
    state.mode = 'create';
  }

  /**
   * Handle toggle edit event
   * @param {string} id
   * */
  function toggleEdit(id: number): void {
    state.drawer = true;
    state.mode = 'edit';
    state.tempExercise = Object.assign({}, state.exerciseList.find(exercise => exercise.id === id)) || {} as SessionExercise;
  }

  /**
   * Handler for close exercise form event
   * */
  function closeEventHandler() {
    state.drawer = false;
    setTimeout(() => {
      state.mode = 'create';
      state.tempExercise = {} as SessionExercise;
    }, 500);
  }

  /**
   * Fetch sessions from api
   * */
  async function fetchSession() {
  }

  /**
   * Fetch session exercise from api
   * */
  async function fetchSessionExercise() {
    try {
      const { data } = await SessionExercise.list(token);
      state.exerciseList = data.map((item: any): SessionExercise => {
        item.name = `Exercise ${item.id}`;
        return item;
      });
    } catch (e) {
      const message: string = e.response ? e.response.data.message || e.response.data.error : e.message;
      throw Error(message);
    }
  }

  /**
   * Handler for create exercise event
   * @param {any} payload
   * */
  async function createExerciseEventHandler(payload: any) {
    state.loading = true;
    try {
      await SessionExercise.create(token, payload);
      await fetchSessionExercise();
      closeEventHandler();
    } catch (e) {
      throw e;
    } finally {
      state.loading = false;
    }
  }

  /**
   * Handler fro edit exercise event
   * @param {any} payload
   * */
  async function editExerciseEventHandler(payload: any) {
    state.loading = true;
    try {
      console.log(payload);
      await SessionExercise.updateExercise(token, state.tempExercise.id as number, payload);
      await fetchSessionExercise();
      closeEventHandler();
    } catch (e) {
      throw e;
    } finally {
      state.loading =false;
    }
  }

  /**
   * Handler for delete exercise event
   * @param {number} id
   * */
  async function deleteExerciseEventHandler(id: number) {
    try {
      await SessionExercise.deleteExercise(token, id);
      await fetchSessionExercise();
      closeEventHandler();
    } catch (e) {
      throw e;
    }
  }

  return {
    ...toRefs(state),
    toggleCreate,
    closeEventHandler,
    fetchSession,
    fetchSessionExercise,
    createExerciseEventHandler,
    toggleEdit,
    editExerciseEventHandler,
    deleteExerciseEventHandler,
  };
}
